import { api } from '../../../shared/services/api';
import type {
  GroupRegistrationPayload,
  GroupRegistrationResponse,
} from '../types/group';

export const groupRegistrationService = {
  registerGroup: async (
    payload: GroupRegistrationPayload,
  ): Promise<GroupRegistrationResponse> => {
    const response = await api.post<GroupRegistrationResponse>('/participants/group', payload);
    return response.data;
  },
};
